// This is a universal link
// on react native we are using a mock of react-router-dom
// lockated in packages/app/__mocks__
import React, { Fragment, useCallback } from 'react';
import { Link as ULink } from 'react-router-dom';
import { LinkProps } from './types';
import { IS_NATIVE } from '@r3l/common';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'app/utils/alert';
import { showModal } from 'modules/navigation/navigation.actions';

export const Link = ({
  webAction,
  nativeAction,
  onClick,
  to,
  target,
  children,
  disabled,
  rel,
  external,
  inline,
  authrequired,
}: LinkProps): JSX.Element => {
  if (disabled) return <Fragment>{children}</Fragment>;
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state: any) => state.auth?.isAuthenticated);

  const handlePress = useCallback(
    (e: any) => {
      // auth interceptor
      if (authrequired && !isAuthenticated) {
        e.preventDefault();
        if (!IS_NATIVE) dispatch(showModal('auth'));
        Alert().alert('You must be signed in to do this');
        return;
      }

      if (IS_NATIVE && nativeAction) return nativeAction(e);
      if (!IS_NATIVE && webAction) return webAction(e);
      if (onClick) return onClick(e);
    },
    [authrequired, isAuthenticated, dispatch, nativeAction, webAction, onClick]
  );

  if (external && !IS_NATIVE)
    return (
      <a href={to} onClick={handlePress} rel={rel} target={target}>
        {children}
      </a>
    );

  return (
    <ULink
      onClick={handlePress}
      rel={rel}
      to={
        external
          ? {
              pathname: to,
            }
          : to
      }
      external={external && !nativeAction}
      target={target}
      inline={inline ? 1 : 0} // used by native component
    >
      {children}
    </ULink>
  );
};
